module.exports = __webpack_public_path__ + "img/logo-light-sternenhimmel.a193badb.png";